import React from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { DivBackgroundOpacity } from "@utils/extra-style";

const CompanyInfo = (props) => {
  const { t, data, isActive } = props;

  return (
    <>
      <DivBackgroundOpacity opacity={isActive === 1 ? 1 : "0.2"}>
        {data}
      </DivBackgroundOpacity>
    </>
  );
};

CompanyInfo.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation()(CompanyInfo);
